import { createFileRoute } from '@tanstack/react-router';

// Trailing-underscore on the parent segment opts this route OUT of nesting under
// the $engagementId detail route — both are standalone pages under the
// /engagements layout gate, rendered at /engagements/$engagementId/intake.
export const Route = createFileRoute('/engagements/$engagementId_/intake')({
  validateSearch: (
    search: Record<string, unknown>,
  ): { party?: string; country?: string; entityType?: string } => ({
    party: typeof search.party === 'string' ? search.party : undefined,
    country: typeof search.country === 'string' ? search.country : undefined,
    entityType: typeof search.entityType === 'string' ? search.entityType : undefined,
  }),
});
